import { connect } from 'react-redux'
import App from '../components/App'
import { getEvents } from '../reducers/events'
import { getTranslatedMessage } from '../utils/translations'
import { getUsers, getOwnId, getCurrentAgent } from '../reducers/users'
import { getRate, getChatState, getIsChatting, getActiveScreen, getNumberInQueue } from '../reducers/app'
import { sendMessage, rateGood, rateBad, sendTranscript, closeChat, savePreForm, sendPostForm } from '../actions/chatActions'

const padZero = x => x < 10 ? "0" + x : x;

const parseTimestamp = timestamp => {
	const date = new Date(timestamp)
	const isPM = date.getHours() >= 12;
	var hours = date.getHours()%12;
	if(hours == 0 && date.getHours() == 12)
	{
		hours =12;
	}
	const minutes = date.getMinutes();
	return `${ padZero(hours) }:${ padZero(minutes) } ${getTranslatedMessage(isPM ? "pm" : "am")}`
}

const parseMessages = messages =>
	messages
		.map(message => ({
			...message,
			parsedDate: parseTimestamp(message.timestamp),
		}))
		.reduce(
			(result, current) => {
				const previous = result[result.length - 1]
				if (!previous.length || previous[previous.length - 1].authorId === current.authorId) {
						result[result.length - 1].push(current)
					return result
				}
				result.push([current])
				return result
			},
			[[]],
		)
		.map(events => events.reduce((result, current) => {
			const isCurrentACarousel = current.title && current.title.startsWith("CAROUSEL:");
			const previous = result[result.length - 1]
			const isPreviousACarousel = 
				previous &&
				previous.length &&
				previous[previous.length - 1] &&
				previous[previous.length - 1].title &&
				previous[previous.length - 1].title.startsWith("CAROUSEL:");
			if (isCurrentACarousel && isPreviousACarousel) {
				previous.push(current);
			} else if (isCurrentACarousel) {
				result.push([current]);
			} else {
				result.push(current);
			}
			return result;
		}, []))

const mapStateToProps = state => {
	return {
		events: parseMessages(getEvents(state)),
		users: getUsers(state),
		ownId: getOwnId(state),
		currentAgent: getCurrentAgent(state),
		rate: getRate(state),
		chatState: getChatState(state),
		isChatting: getIsChatting(state),
		activeScreen: getActiveScreen(state),
		numberInQueue: getNumberInQueue(state),
	}
}

const mapDispatchToProps = dispatch => ({
	onMessageSend: data => {
		dispatch(
			sendMessage({
				text: data,
				post: data
			}),
		)
	},
	sendMessage: (text,post) =>
		dispatch(
			sendMessage({
				text,
				post: post
			}),
		),
	rateGood: () => {
		dispatch(rateGood())
	},
	rateBad: () => {
		dispatch(rateBad())
	},
	closeChat: () => {
		dispatch(closeChat())
	},
	savePreForm: payload => {
		dispatch(savePreForm(payload))
	},
	sendPostForm: payload => {
		dispatch(sendPostForm(payload))
	},
	sendTranscript: (email) => {
		dispatch(sendTranscript({email}))
	}
})

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App)
export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js